import useWidth from '../useWidth';

/**
 * Number of image tiles per row for the VIMDT galleries, based on viewport width.
 */
export default function useRowCount() {
	const width = useWidth();

	if (width === undefined) return 6;
	if (width <= 520) return 2;
	if (width <= 768) return 3;
	if (width <= 1400) return 4;
	return 6;
}
